import {
  standardRequestWithPendingFlash,
  type RequestInstance,
} from 'shared/utils/request';
import type { DataCollectionRuleInterface } from './../components/data_collection_rules/data_collection_rule';
import { DataRetentionRule } from './../components/data_retention_rules/data_retention_rule';

function generate(
  path: string,
  object: DataRetentionRule | DataCollectionRuleInterface
): string {
  if (object && object.id) {
    return `${path}/${object.id}`;
  }

  return path;
}

type Requester = RequestInstance & {
  [fn: string]: any;
};

const withRequest =
  (req: Requester): any =>
  (method: string): any =>
  (
    path: string,
    object: DataRetentionRule | DataCollectionRuleInterface,
    options: {
      scope: string | null | undefined;
    } = { scope: null }
  ): Promise<any> =>
    req[method](
      generate(path, object),
      options.scope ? { [options.scope]: object } : object
    );

const request = withRequest(standardRequestWithPendingFlash);

export const create = request('post');
export const read = request('get');
export const update = request('put');
export const destroy = request('delete');
